<template>
  <div style="background: #f8f8f8;">
    {{checkRl}}/{{ucrl}}/{{startR}}/{{recordedBlobs.length}}
    <!-- <video autoplay id="video"></video> -->
    <!-- <btn @click="pass">通过</btn>
     <btn @click="fail">不通过</btn> -->
    <div></div>
    <video
      id="video"
      playsinline
      ref="refVideo"
      webkit-playsinline
    >
    </video>
    <!-- <canvas id="canvas-face" width="300px" height="300px" class="bh"></canvas> -->
    <div class="tip1" v-if="!djsFlag">{{ scanTip }}</div>
    <div class="tip1" v-if="djsFlag && !startR">即将开始</div>
    <div class="tip4" v-if="djsFlag && startR">保持您的脸出现在取景框内</div>
    <!-- <div class="tip1" v-if="djsFlag && startR">检测中..</div> -->
    <div class="tip2" v-show="djsFlag && djsN>= 1">{{djsN}}</div>
    <div class="tip3" v-show="djsFlag &&djsN === 0">{{sl.text}}</div>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper " @click.stop>
        <div v-if="ntype=== 2">
          <div class="ht90"/>
          <div class="fsac noticeZone">
            <div class="noticeTxt">你已通过年审</div>
          </div>
          <div class="fsac noticeZone">
            <van-icon name="checked"  color="#1678ff" size="25vw"/>  
          </div>
          <div class="ht90"/>
           <!-- <div class="scctip">下次年审时间：2022-12-01~2022-12-31</div> -->
          <div class="fsac myBtn">
            <van-button round type="info" plain size="small" color="#1678ff" @click="goto">
              <div style="width: 20vw">确认</div>
            </van-button>
          </div>
        </div>
        <div v-if="ntype=== 3">
          <div class="ht90"/>
          <div class="fsac noticeZone">
            <div class="noticeTxt">年审未通过</div>
          </div>
          <div class="fsac noticeZone">
            <van-icon name="warning"  color="#DC143C" size="25vw"/>  
          </div>
          <div class="ht90"/>
           <div class="scctip">{{tipfail}}</div>
          <div class="fsac myBtn">
            <van-button round type="info" plain size="small" color="#1678ff" @click="goto">
              <div style="width: 20vw">返回</div>
            </van-button>
          </div>
        </div>
        <div v-if="ntype=== 4">
          <div class="ht90"/>
          <div class="fsac noticeZone">
            <div class="noticeTxt">年审重复</div>
          </div>
          <div class="fsac noticeZone">
            <van-icon name="warning"  color="#DC143C" size="25vw"/>  
          </div>
          <div class="ht90"/>
           <div class="scctip">{{tipfail}}</div>
          <div class="fsac myBtn">
            <van-button round type="info" plain size="small" color="#1678ff" @click="goto">
              <div style="width: 20vw">返回</div>
            </van-button>
          </div>
        </div>
        <div v-if="ntype=== 1">
          <div class="ht90"/>
          <div class="fsac noticeZone">
            <div class="noticeTxt">检测中...</div>
          </div>
          <div class="fsac noticeZone">
            <van-loading size="20vw" vertical>检测中...</van-loading>
          </div>
          <div class="ht90"/>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast, Overlay, Icon, Button, Loading  } from 'vant'
export default {
  components: {
     [Toast.name]: Toast,
     [Overlay.name]: Overlay,
     [Icon.name]: Icon,
     [Button.name]: Button,
     [Loading.name]: Loading
  },
  data () {
    return {
      screenSize: {
        width: window.screen.width,
        height: window.screen.height    
      },
      ntype: 0,
      URL: null,
      streamIns: null, // 视频流
      showContainer: true, // 显示
      tracker: null,
      tipFlag: false, // 提示用户已经检测到
      flag: false, // 判断是否已经拍照
      context: null, // canvas上下文
      profile: [], // 轮廓
      removePhotoID: null, // 停止转换图片
      scanTip: "人脸识别中...", // 提示文字
      imgUrl: "",      canvas: null,
      trackertask: null,
      vwidth: "100%",
      vheight: "100%",
      cwidth: "266",
      cheight: "266",
      userInfo: {},
      orderData: {},
      trackerTask: '',
      mediaStreamTrack: '',
      checkRl: 0,
      ucrl: 0,
      startR: false,
      recordedBlobs: [],
      url: '',
      djsFlag: false,
      djsN: 3,
      f1: 'video/webm',
      checkRlLimit: 6,
      solutions: [
        {text: '请张张嘴', actions: '[3]'},
        {text: '请眨眨眼', actions: '[4]'}
      ],
      show: false,
      sl: {text: '', actions: ''},
      tipfail: '',
      userId: '',
      userType: ''
    }
  },
  async mounted () {
    await this.sbj()
    this.checkPlatForm()
    this.djsFlag = false
    this.djsN = 3
    this.startR = false
    this.playVideo()
  },
  methods: {
    pass () {
      this.show = true
    },
    fail () {

    },
    async sbj () {
      let{userId, userType} = this.$route.query
      this.userId = userId
      this.userType = Number(userType)
      if (this.userType === 2 && !this.userId) {
        Toast('非法访问！')
        this.$router.replace('/index')
      }
    },
    checkPlatForm () {
      let os = window.localStorage.getItem('os').toLowerCase()
      let version = window.localStorage.getItem('version')
      if (os === 'android' && Number(version < 10)) {
        this.checkRlLimit = 5
      } 
      let f1 = window.localStorage.getItem('f1')
      alert(f1)
      if (f1) {
        this.f1 = f1
      }
      let r = Math.random() 
      if (r > 0.5) {
        this.sl = this.solutions[1]
      } else {
        this.sl = this.solutions[0]
      }
    },
    genTime () {
      let a = new Date()
      let y = a.getFullYear()
      let m = a.getMonth() + 1
      let D = a.getDate()
      let H = a.getHours() //获取当前小时数(0-23)
      let M = a.getMinutes()
      let S = a.getSeconds() //获取当前秒数(0-59)
      return `${y}-${m}-${D} ${H}:${M}:${S}`
    },
    goto () {
      this.$router.replace('/my')
    },
    refresh () {
      window.location.reload()
    },
    showLoading(t = true) {
      this.show = true
      this.ntype = 1
      // Toast.loading({
      //   message: '检测中...',
      //   forbidClick: true,
      //   overlay: t,
      //   duration: 0
      // })
    },
    playVideo() {
      this.getUserMedia({ //摄像头拍摄的区域
        audio: false,
        video: {
          // width: 500,
          // height: 500,
          width: {
              min: 600,
              max: 600
          },
          height: {
              min: 600,
              max: 600
          },
            frameRate: {
            min: 15,
            ideal: 30,
            max: 30,
          },
          // facingMode: { exact: "environment" }
          facingMode: "user"
        } , 
      }, this.success2, this.error ) 
    },
      // 访问用户媒体设备    
    getUserMedia(constrains, success, error) {   
      if (navigator.getUserMedia) { //旧版API
        try {
          window.navigator.getUserMedia(constrains, success, error)
        } catch (e) {
          alert(11111)
        }
      } else if (window.navigator.webkitGetUserMedia) { //webkit内核浏览器
        alert(2)
        window.navigator.webkitGetUserMedia(constrains, success, error)
      } else if (window.navigator.mediaDevices && window.navigator.mediaDevices.getUserMedia) { //最新标准API
        alert(1)
        window.navigator.mediaDevices.getUserMedia(constrains).then(success).catch(error)
      } else if (navigator.mozGetUserMedia) { //Firefox浏览器 
        alert(3)
        window.navigator.mozGetUserMedia(constrains, success, error) 
      } else {
        this.scanTip = "你的浏览器不支持访问用户媒体设备"  
      }    
    },
    success2(stream) {
      this.streamIns = stream
      console.log(stream, 909990900)
      // 设置播放地址，webkit内核浏览器
      this.URL = window.URL || window.webkitURL
      if ("srcObject" in this.$refs.refVideo) {
        this.$refs.refVideo.srcObject = stream
      } else {
        this.$refs.refVideo.src = this.URL.createObjectURL(stream)
      }
      this.$refs.refVideo.onloadedmetadata = e => {
          // 播放视频
        this.$refs.refVideo.play()
        this.initTracker()
      }
    },
    initTracker() {
      let tracking = window.tracking
      // const canvas = document.getElementById('canvas-face')
      // this.context = canvas.getContext('2d')
      // this.context = this.$refs.refCanvas.getContext("2d")    // 画布
      this.tracker = new tracking.ObjectTracker(['face'])     // tracker实例
      this.tracker.setStepSize(1.7)                           // 设置步长
      this.tracker.on('track', this.handleTracked)            // 绑定监听方法
      try {
        tracking.track('#video', this.tracker)      // 开始追踪
        console.log('开始追踪人脸！！！！')
      } catch (e) {
        this.scanTip = "访问用户媒体失败，请重试"
      }
    },
    handleTracked(e) {
      // console.log(e)
      if (e.data.length === 0) {
        this.ucrl += 1
        if (!this.checkRl) {
          this.scanTip = '未检测到人脸'
        }
      } else {
        this.scanTip = '检测到人脸'
        this.checkRl += 1
        if (this.checkRl > this.checkRlLimit && !this.djsFlag) {
          this.djs()
          // this.startRecording()
        }
        // console.log('检测到人脸')
        // console.log(e)
      }
    },
    djs () {
      this.scanTip = '准备开始检测'
      let self = this
      setInterval(() => {
        if (self.djsN > 0) {
          self.djsN -=1
        } else {
          this.scanTip = '请遵照提示'
          if (!this.startR) {
            self.startRecording()
            // alert('recording')
            // this.startR = true
          }
        }
      }, 800)
      // self.startRecording()
      this.djsFlag = true
    },
    startRecording() {
      if (this.startR) {
        return
      }
      this.startR = true
      this.recordedBlobs = []
      let mimeType = this.f1
      let options = {mimeType, videoBitsPerSecond: 768000}
      // let options = {videoBitsPerSecond: 640000}
      let mediaRecorder
      try {
        mediaRecorder = new window.MediaRecorder(this.streamIns, options)
      } catch (e) {
          console.error('检测人脸中发生错误: ' + e);
          alert('人脸检测中发生错误: '
          + e + '. mimeType: ' + options.mimeType);
          return;
      }
      // recordButton.textContent = '结束录制';
      // uploadButton.disabled = true;
      mediaRecorder.onstop = this.handleStop
      mediaRecorder.ondataavailable = this.handleDataAvailable
      mediaRecorder.start(5000); // collect 10ms of data
      setTimeout(() => {
        mediaRecorder.stop()
      }, 3500);
      // mediaRecorder.stop()
      console.log('MediaRecorder started', mediaRecorder);
    },
    handleStop(event) {
      // console.log('Recorder stopped: ', event)
      // const fullBlob = new Blob(this.recordedBlobs)
      this.upload()
    },
    async upload(){
        //保存在本地，通过post请求
        //还可以用append方法添加一些附加信息参数为(name,value)，如下面的代码：
      let stream = this.streamIns
      stream.getTracks().forEach(track => track.stop())
      var blob = new Blob(this.recordedBlobs)
      this.showLoading()
      var formData = new FormData()
      let name = window.localStorage.getItem('name') || '吕晶'
      let cardNo = window.localStorage.getItem('cardNo') || '510108198501131838'
      formData.append('file', blob)
      formData.append('actions', this.sl.actions)
      if (this.userType === '3') {
        formData.append('userId', this.userId)
      }
      // formData.append('name', name)
      // formData.append('cardNo', cardNo)
      let r = await this.$api.userAudit(formData)
      let key = `${cardNo}-${name}`
      let time = this.genTime()
      let t = window.localStorage.getItem(key)
      t = t ? JSON.parse(t) : []
      // window.localStorage.setItem(key, JSON.stringify(t))
      let v
      let {code, info, success} = r
      if (success) {
        v = {time, value: '通过'}
        t.push(v)
        this.ntype = 2
      } else if (code === 308) {
        v = {time, value: '您已进行过年审'}
        t.push(v)
        this.tipfail = info
        this.ntype = 4
      } else {
        v = {time, value: '年审未通过'}
        t.push(v)
        this.tipfail = info
        this.ntype = 3
      }
      Toast.clear()
    },
    handleDataAvailable(event) {
      console.log(event)
      if (event.data && event.data.size > 0) {
        this.recordedBlobs.push(event.data);
      }
    },
    error(e) {
      alert('error:' + e.name + e.stack)
      this.scanTip = e   
    }
  }
}
</script>

<style>
  .wrapper {
    width: 375px;
    height: 100%;
    background: #fff;
  }
  .noticeZone {
    /* margin-top: 100px; */
    height: 150px;
  }
  .scctip {
    height: 40px;
    line-height: 40px;
    color: #555;
    font-size: 14px;
    text-align: center;
  }
  .noticeTxt {
    color: #444;
    font-size: 26px
  }
  .tip1 {
    width: 100%;
    height: 48px;
    line-height: 48px;
    font-size: 48px;
    text-align: center;
    margin-top: 20px;
  }
  .tip4 {
    width: 100%;
    height: 48px;
    line-height: 48px;
    font-size: 30px;
    text-align: center;
    margin-top: 20px;
  }
  .tip2 {
    width: 100%;
    height: 240px;
    line-height: 240px;
    font-size: 108px;
    text-align: center;
    margin-top: 10px;
  }
  .tip3 {
    width: 100%;
    height: 80px;
    line-height: 80px;
    font-size: 80px;
    text-align: center;
    margin-top: 10px;
  }
  video {
    margin-left: 10vw;
    width: 80vw;
    height: 80vw;
    /* margin: 50px auto; */
    background-color: transparent;
    border-radius: 50%;
    transform: rotateY(180deg)
    /* display: block; */
  }
</style>